var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c(_vm.renderTemp,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }